var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('keep-alive',{key:_vm.$store.getters.getToken || 'anonymous',attrs:{"include":"ControlPage"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }